import request from '@/utils/request'

const baseApi = process.env.VUE_APP_BIDDOG_API

// 获取采购单位/竞争对手列表
export function getCompanyApi(params) {
  return request(
    {
      url: baseApi + `/mark/companies/page`,
      method: 'get',
      params
    },
    { needLoading: false }
  )
}

// 获取竞争对手画像
export function getSupplierPortraitApi(companyId, params) {
  return request({
    url: baseApi + `/analysis/companies/${companyId}/supplier/portrait`,
    method: 'get',
    params
  })
}

// 获取采购单位画像
export function getPurchaserPortraitApi(companyId, params) {
  return request({
    url: baseApi + `/analysis/companies/${companyId}/purchaser/portrait`,
    method: 'get',
    params
  })
}

// 获取公司信息
export function getCompanyInfoApi(companyId) {
  return request({
    url: baseApi + `/analysis/companies/${companyId}/info`,
    method: 'get'
  })
}

// 获取公司变更记录
export function getCompanyChangeRecordApi(companyId, params) {
  return request({
    url: baseApi + `/analysis/companies/${companyId}/change/record/page`,
    method: 'get',
    params
  })
}

// 获取公司采购项目
export function getCompanyPurchaserOrdersApi(companyId, params) {
  return request({
    url: baseApi + `/analysis/companies/${companyId}/purchaser/orders`,
    method: 'get',
    params
  })
}

// 查询画像状态
export function getPortraitStatusApi(companyId) {
  return request({
    url: baseApi + `/analysis/companies/${companyId}/portrait/status`,
    method: 'get'
  })
}

// 购买画像
export function portraitBuyApi(companyId) {
  return request({
    url: baseApi + `/analysis/companies/${companyId}/portrait/buy`,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
